export enum Departments {
    CTS= 37189923,
    DCS = 37230063,
    PrivateCounsel = 37226815
}

export enum ContactType {
    DaytimePhone = 37191946,
    HomePhone = 2682,
    MessagePhone = 2686,
    MobilePhone = 37183339,
    WorkPhone = 2683,
    EmailAddress = 2687
}

export enum CaseType {
    JV = "Delinquency",
    JD= "Dependency",
    JA = "Adoption",
    AC = "Adoption Certification"
}